import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import './style.scss';

import img1 from '../../../../assets/t-401/Munch.jpg';
import img2 from '../../../../assets/t-401/Monsted.jpg';
import img3 from '../../../../assets/t-401/Delaunay.jpg';
import img4 from '../../../../assets/t-401/Gauguin.jpg';
import img5 from '../../../../assets/t-401/Sohlberg.jpg';

type Props = {
    onComplete?: () => void
}

const DATA = [
    [img1, 'Elm Forest in Spring (ca. 1923) Edvard Munch (Norwegian, 1863 - 1944)'],
    [img2, 'A wooded river landscape (1892),<br />Peder Mørk Mønsted (Danish , 1859 – 1941)'],
    [img3, 'Soleil, tour, aéroplane (Sun, Tower, Airplane) (1913), Robert Delaunay (French, 1885-1941)'],
    [img4, 'Houses at Vaugirard, Paul Gauguin (French, 1848-1903)'],
    [img5, 'Winter Night in the Mountains. Study (from 1901 until 1902), Harald Sohlberg (Norwegian, 1877 - 1935)'],
]

const Task401: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-401');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-401">
        <h2>zadanie 1</h2>
        <h3>{task?.title}</h3>
        <div className="poem">

            <figure>
                <figcaption>
                    Zbigniew Herbert
                </figcaption>
                <blockquote>
                    "kukułka<br />
                    wywoła drzewa<br />
                    jedno i drugie<br />
                    aż stanie<br />
                    las<br />
                    <br />
                    zaświstaj cienko -<br />
                    a pobiegnie rzeka<br />
                    mocna nić<br />
                    która zwiąże góry z dolinami<br />
                    <br />
                    Chrząknij znacząco -<br />
                    oto miasto<br />
                    z jedną wieżą<br />
                    szczerbatym murem<br />
                    i domkami żółtymi<br />
                    jak kostki do gry<br />
                    teraz<br />
                    zamknij oczy<br />
                    spadnie śnieg<br />
                    zgasi<br />
                    zielone płomyki drzew<br />
                    wieżę czerwoną"
                </blockquote>
            </figure>
        </div>
        <p>Poszukaj w bibliotece tomików Zbigniewa Herberta i przeczytajcie cały wiersz na głos.</p>
        <p className="instruction"><strong>Zadanie:</strong> Zobacz, jakie tropy niczym nieposkromionej wyobraźni podsuwa nam w swoim wierszu Zbigniew Herbert. Spośród obrazów poniżej wybierzcie te, które najlepiej Waszym zdaniem oddają atmosferę wiersza. Poszukajcie też własnych metafor wyobraźni korzystając z <a href="https://artvee.com/" target="_blank" rel="noreferrer">Artvee</a>, czyli wyszukiwarki dzieł sztuki z domeny publicznej.</p>
        <div className="paintings">
            {
                DATA.map((img, index) => {
                    return <label key={index}>
                        <input type="checkbox" />
                        <figure>
                            <img src={img[0]} alt="" />
                            <figcaption dangerouslySetInnerHTML={{__html: img[1]}}></figcaption>
                        </figure>
                    </label>
                })
            }
        </div>
    </div>
}

export default Task401;
